import { render, staticRenderFns } from "./TariffCreate.vue?vue&type=template&id=60cff9da&"
import script from "./TariffCreate.vue?vue&type=script&lang=js&"
export * from "./TariffCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports